import SvgCalendar from '@img/icons/calendar.svg';
import SvgClock from '@img/icons/clock.svg';
import SvgFeedArticleIcon from '@img/icons/feed-article-icon.svg';
import SvgFeedBlog from '@img/icons/feed-blog-icon.svg';
import SvgFeedEventIcon from '@img/icons/feed-event-icon.svg';
import SvgFeedPublicationIcon from '@img/icons/feed-publication-icon.svg';
import SvgFeedWhiteVideoIcon from '@img/icons/feed-video-icon-white.svg';
import SvgFeedVideoIcon from '@img/icons/feed-video-icon.svg';
import SvgLocation from '@img/icons/location.svg';
import { FakeButton, LinkButton } from '@stories/Components/Buttons/Button/Button';
import Image from '@stories/Components/Misc/Image/Image';
import * as React from 'react';
import S from './FeedCard.styles';
export var FeedCardType;
(function (FeedCardType) {
    FeedCardType["Generic"] = "generic";
    FeedCardType["Article"] = "article";
    FeedCardType["Event"] = "event";
    FeedCardType["Publication"] = "publication";
    FeedCardType["Video"] = "video";
    FeedCardType["People"] = "people";
    FeedCardType["Blog"] = "blog";
    FeedCardType["Office"] = "office";
})(FeedCardType || (FeedCardType = {}));
const FeedCard = ({ type, title, image, description, date, time, location, cta, isFeatured, featuredText, }) => {
    const linkProps = {
        as: type === FeedCardType.Office ? 'div' : undefined,
        ...(type !== FeedCardType.Office ? { href: cta.url, target: cta.target ?? '_self' } : {}),
    };
    const featuredAttrs = isFeatured ? { 'data-featured': true } : {};
    return (React.createElement(S.Container, { "data-type": type, ...featuredAttrs },
        React.createElement(S.Link, { ...linkProps },
            isFeatured && React.createElement(S.FeaturedText, null, featuredText),
            React.createElement(S.Snippets, null,
                date && (React.createElement(S.Date, null,
                    React.createElement(SvgCalendar, null),
                    " ",
                    date)),
                time && (React.createElement(S.Time, null,
                    React.createElement(SvgClock, null),
                    " ",
                    time)),
                location && (React.createElement(S.Location, null,
                    React.createElement(SvgLocation, null),
                    " ",
                    location)),
                React.createElement(S.IconHolder, null, getFeedIcon(type))),
            image && (React.createElement(S.ImageWrapper, null,
                React.createElement(Image, { loading: "lazy", image: image, width: type === FeedCardType.Office ? 450 : 333 }))),
            React.createElement(S.Title, { as: type === FeedCardType.Office ? 'h2' : 'h3' }, title),
            description && React.createElement(S.Description, { dangerouslySetInnerHTML: { __html: description } }),
            cta && cta.text && (React.createElement(S.CtaWrapper, null, type === FeedCardType.Office ? (React.createElement(LinkButton, { buttonType: "text-only", href: cta.url, target: cta.target ?? '_self' }, cta.text)) : (React.createElement(FakeButton, { buttonType: type === FeedCardType.People ? 'ghost' : 'text-only' }, cta.text)))))));
    function getFeedIcon(type) {
        switch (type) {
            case FeedCardType.Event:
                return React.createElement(SvgFeedEventIcon, null);
            case FeedCardType.Publication:
                return React.createElement(SvgFeedPublicationIcon, null);
            case FeedCardType.Blog:
                return React.createElement(SvgFeedBlog, null);
            case FeedCardType.Video:
                return (React.createElement(React.Fragment, null,
                    React.createElement(SvgFeedVideoIcon, null),
                    React.createElement(SvgFeedWhiteVideoIcon, null)));
            case FeedCardType.Article:
                return React.createElement(SvgFeedArticleIcon, null);
            default:
                return null;
        }
    }
};
export default FeedCard;
